<template>
  <div class="replacements-page">
    <app-view-layout header="Kalendarz nieobecności">
      <template #content>
        <div class="mt-6">
          <v-toolbar flat>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              class="mr-2"
              @click="next"
            >
              <v-icon>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
          </v-toolbar>

          <v-calendar
            ref="calendar"
            v-model="date"
            locale="pl"
            type="month"
            :weekdays="staticData.weekdays"
            :events="getReplacementsArray"
          />
        </div>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';

export default {
  components: {
    AppViewLayout,
  },
  data: () => ({
    staticData: {
      weekdays: [1, 2, 3, 4, 5, 6, 0],
    },
    date: '',
  }),

  computed: {
    ...mapGetters('users', [
      'getReplacementsArray',
    ]),
  },

  created() {
    this.setSorting({
      field: 'name',
      direction: 'asc',
    }).then(() => {
      this.setItemsPerPage(9999);
      this.fetchUsers();
      this.setItemsPerPage(12);
    });
  },
  methods: {
    ...mapActions('users', [
      'fetchUsers',
    ]),

    ...mapActions('filters', [
      'setSorting',
    ]),

    ...mapActions('pagination', [
      'setItemsPerPage',
    ]),
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
  },
};
</script>

<style lang="scss" scoped>
.replacements-page::v-deep .v-calendar-weekly__week {
  min-height: 100px;
}
</style>
